// This module loads rate data at runtime from a JSON file
// to avoid webpack compilation of the massive 780KB dataset

let _data = null;
let _loading = false;
let _loaded = false;
let _callbacks = [];

// Cache for computed state-specific data
const _stateCache = new Map();

export const loadRateData = () => {
  if (_loaded) return Promise.resolve(_data);
  if (_loading) return new Promise(resolve => _callbacks.push(resolve));
  _loading = true;
  return fetch('/data/rates.json')
    .then(r => r.json())
    .then(d => {
      _data = Object.freeze(d); // Freeze to prevent accidental mutations
      _loaded = true;
      _loading = false;
      _callbacks.forEach(cb => cb(d));
      _callbacks = [];
      return d;
    });
};

// Get WC rates for a specific state (cached)
export const getStateWcRates = (state) => {
  if (!_loaded || !_data) return null;
  
  const cacheKey = `wc_${state}`;
  if (_stateCache.has(cacheKey)) {
    return _stateCache.get(cacheKey);
  }
  
  const stateRates = _data.DEFAULT_WC_RATES?.[state] || {};
  _stateCache.set(cacheKey, stateRates);
  return stateRates;
};

// Get SUTA base for a specific state
export const getStateSutaBase = (state) => {
  if (!_loaded || !_data) return null;
  return _data.DEFAULT_SUTA_BASES?.[state] || null;
};

// Clear cache (useful for testing or when data is reloaded)
export const clearCache = () => {
  _stateCache.clear();
};

export const getRateData = () => _data;
export const isRateDataLoaded = () => _loaded;
